import { Button } from "@deligoo/ui"
import clsx from "clsx"
import { forwardRef, HTMLAttributes } from "react"

import cls from "./Card.module.scss"

type CardProps = {
  box?: boolean
} & HTMLAttributes<HTMLDivElement>

export const Card = ({ box, className, children, ...props }: CardProps) => {
  return (
    <div className={clsx(cls.card, box && cls.box, className)} {...props}>
      {children}
    </div>
  )
}

const Header = ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <header className={clsx(cls.header, className)} {...props}>
      {children}
    </header>
  )
}

const Section = forwardRef(({ className, children, ...props }: HTMLAttributes<HTMLDivElement>, ref) => {
  return (
    <div ref={ref as React.RefObject<HTMLDivElement>} className={clsx(cls.section, className)} {...props}>
      {children}
    </div>
  )
})

type CloseProps = {
  circle?: boolean
  handleClose: () => void
}

const Close = ({ circle, handleClose }: CloseProps) => {
  return (
    <Button
      title="Zamknij"
      variation="text"
      size="small"
      className="ml-auto"
      onClick={handleClose}
      iconProps={{
        name: circle ? "close-circle" : "close",
        color: "primary",
        className: cls.closeIcon,
      }}
      pill
    />
  )
}

Card.Header = Header
Card.Section = Section
Card.Close = Close
